import { X } from "lucide-react";
import { cn } from "@/lib/utils";
import type { LightboxCloseButtonProps } from "./types";

export function LightboxCloseButton({
  onClose,
  backLabel,
}: LightboxCloseButtonProps) {
  return (
    <button
      onClick={onClose}
      className={cn(
        "flex items-center gap-2 px-3 py-2",
        "rounded-xl bg-muted/50 hover:bg-muted text-foreground font-bold",
        "transition-all hover:scale-[1.02] active:scale-[0.98]"
      )}
    >
      <X className="w-5 h-5" />
      <span className="hidden sm:inline">{backLabel}</span>
    </button>
  );
}
